export const TOUR_STEPS = {
  national_admin: [
    {
      target: '[data-testid="sop-stats-section"]',
      title: "Statistiques en un coup d'œil",
      content: "Suivez le nombre de SOP par site et par année, avec un histogramme et un tableau croisé.",
    },
    {
      target: '[data-testid="search-keyword-input"]',
      title: "Recherche",
      content: "Recherchez une SOP par mot-clé (titre, site, créateur...).",
    },
    {
      target: '[data-testid="filter-site-select"]',
      title: "Filtres",
      content: "Filtrez la liste par site, service ou année pour retrouver rapidement une procédure.",
    },
    {
      target: '[data-testid="dashboard-new-sop-button"]',
      title: "Créer une SOP",
      content: "En tant qu'Administrateur National, vous pouvez créer une SOP pour n'importe quel site.",
    },
    {
      target: '[data-testid="nav-users-button"]',
      title: "Gestion des utilisateurs",
      content: "Gérez les rôles (Créateur, Valideur, Admin Site), les services et les Administrateurs Nationaux depuis ce bouton.",
    },
  ],
  site_admin: [
    {
      target: '[data-testid="user-management-page"]',
      title: "Gestion de vos sites",
      content: "Cette page vous permet de gérer les droits d'accès, mais uniquement pour vos propres sites.",
      placement: "center",
    },
    {
      target: '[data-testid="add-site-section"]',
      title: "Ajouter un service",
      content: "Ajoutez un nouveau service pour l'un de vos sites - le choix du site est limité à ceux que vous administrez.",
    },
    {
      target: '[data-testid="site-search-input"]',
      title: "Rechercher un site",
      content: "Si vous gérez plusieurs sites, utilisez cette recherche pour les retrouver rapidement.",
    },
  ],
  validator: [
    {
      target: '[data-testid="wizard-tab-informations"]',
      title: "Vérifiez les informations",
      content: "Avant de valider, relisez le titre, le site et le créateur, puis parcourez les onglets Étapes et EPI pour vérifier le contenu complet.",
    },
    {
      target: '[data-testid="form-validateur-input"]',
      title: "Indiquez votre nom",
      content: "Une fois la SOP vérifiée et correcte, indiquez votre nom ici : c'est ce qui matérialise votre validation.",
    },
    {
      target: '[data-testid="wizard-tab-recap"]',
      title: "Enregistrer",
      content: 'Allez enfin dans l\'onglet "Récapitulatif" et cliquez sur "Enregistrer" pour valider définitivement la SOP.',
    },
  ],
};
